module.exports = __webpack_public_path__ + "glass.11433e1493edbba9fe71.jpg";


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/assets/img/glass.jpg
// module id = ../../../../../src/assets/img/glass.jpg
// module chunks = styles